import React, { useState } from "react";
import "./App.css";
import { ThemeProvider } from "@mui/material";
import theme from "./theme";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { GetStartedPage } from "./pages/GetStartedPage";
import { BlocksOverviewPage } from "./pages/BlocksOverviewPage";
import { BlocksVariablePage } from "./pages/BlocksVariablePage";
import { BlockResponsePage } from "./pages/BlocksResponsePage";
import { BlocksIfPage } from "./pages/BlocksIfPage";
import { BlocksLoopPage } from "./pages/BlocksLoopPage";
import { BlocksFetchOnePage } from "./pages/BlocksFetchOnePage";
import { BlocksFetchManyPage } from "./pages/BlocksFetchManyPage";
import { BlocksCreatePage } from "./pages/BlocksCreatePage";
import { BlocksUpdatePage } from "./pages/BlocksUpdatePage";
import { BlocksDeletePage } from "./pages/BlocksDeletePage";
import { BlocksUserSignupPage } from "./pages/BlocksUserSignupPage";
import { BlocksUserSigninPage } from "./pages/BlocksUserSigninPage";

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <BrowserRouter basename={"/docs"}>
          <Routes>
            <Route path="/" element={<GetStartedPage />}></Route>
            <Route path="/getstarted" element={<GetStartedPage />}></Route>
            <Route
              path="/blocks/overview"
              element={<BlocksOverviewPage />}
            ></Route>
            <Route
              path="/blocks/variables"
              element={<BlocksVariablePage />}
            ></Route>
            <Route path="/blocks/response" element={<BlockResponsePage />} />
            <Route path="/blocks/if" element={<BlocksIfPage />} />
            <Route path="/blocks/loop" element={<BlocksLoopPage />} />
            <Route path="/blocks/fetchone" element={<BlocksFetchOnePage />} />
            <Route path="/blocks/fetchmany" element={<BlocksFetchManyPage />} />
            <Route path="/blocks/create" element={<BlocksCreatePage />} />
            <Route path="/blocks/update" element={<BlocksUpdatePage />} />
            <Route path="/blocks/delete" element={<BlocksDeletePage />} />
            <Route
              path="/blocks/usersignup"
              element={<BlocksUserSignupPage />}
            />
            <Route
              path="/blocks/usersignin"
              element={<BlocksUserSigninPage />}
            />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
